export default __webpack_public_path__ + "a77b35ba37a2e4cc3808ee42b905cec9.png";